import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      sortable: true,
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      sortable: true,
    },
    {
      prop: 'type',
      label: i18n.t('common_words.type_grade'),
      sortable: true,
    },
    {
      prop: 'audit_type_label',
      label: i18n.t('common_words.type_capture'),
      sortable: true,
    },
    {
      prop: 'username',
      label: i18n.t('common_words.user'),
      sortable: true,
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
};

export default configTable;
